package info.rezident.app.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.Svg
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.icons.fa.FaInstagram
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import info.rezident.app.core.AppTracking
import info.rezident.app.data.auth.AuthRepository
import info.rezident.app.seo.setMetaNameTag
import info.rezident.app.ui.components.animations.ConfettiAnimation
import info.rezident.app.ui.components.widgets.Spacer
import info.rezident.app.ui.theme.AppTheme
import kotlinx.browser.document
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.dom.Div

@Page
@Composable
fun SuccessPage() {
    LaunchedEffect(Unit) {
        document.title = "Felicitări!"
        document.setMetaNameTag(name = "robots", content = "noindex, nofollow")
    }

    val breakpoint = rememberBreakpoint()
    var userName by remember { mutableStateOf("") }

    LaunchedEffect(Unit) {
        userName = AuthRepository.getCurrentUser()?.displayName ?: "Viitor Dr."
    }

    Box(
        Modifier
            .fillMaxSize()
            .backgroundColor(AppTheme.colors.background),
        contentAlignment = Alignment.Center
    ) {
        // Confetti animation layer
        ConfettiAnimation()

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .fillMaxHeight(90.percent)
                .padding(leftRight = 24.px, bottom = if (breakpoint < Breakpoint.MD) 32.px else 48.px),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Spacer(Modifier.weight(1f))

            SuccessBadge()

            Spacer(Modifier.height(32.px))

            SpanText(
                userName?.let { name ->
                    "Felicitări, ${name.takeWhile { it != ' ' }}!"
                } ?: "Felicitări!",
                AppTheme.typography.h1.toModifier()
                    .fontWeight(FontWeight.Bold)
                    .color(Color.rgb(34, 197, 94))
            )

            Spacer(Modifier.height(16.px))

            SpanText(
                "Te-ai alăturat altor zeci de studenți care așteaptă cu nerăbdare lansarea.",
                AppTheme.typography.body1Medium.toModifier()
                    .color(AppTheme.colors.textSecondary)
            )

            SpanText(
                "Verificăm ultimele detalii pentru ca tu să ai cea mai bună experiență",
                AppTheme.typography.body1.toModifier()
                    .color(AppTheme.colors.textTertiary)
            )

            Spacer(Modifier.weight(2f))

            Box(
                Modifier
                    .fillMaxWidth()
                    .padding(bottom = 16.px),
                contentAlignment = Alignment.BottomCenter
            ) {
                SpanText(
                    "Vom anunța pe pagina de Instagram când sunt gata recomandările",
                    AppTheme.typography.body1.toModifier()
                        .color(AppTheme.colors.textSecondary)
                )
            }
            Link(
                "https://www.instagram.com/rezident.info/",
                AppTheme.typography.body1.toModifier()
                    .onClick { AppTracking.logEvent(AppTracking.EVENT_WAITLIST_INSTAGRAM_CLICK) }
            ) {
                FaInstagram(
                    Modifier.color(AppTheme.colors.textSecondary),
                    size = IconSize.X4
                )
            }
        }
    }
}

@Composable
private fun SuccessBadge() {
    Box(
        Modifier
            .size(120.px)
            .backgroundColor(Color.rgb(34, 197, 94)) // Green glow
            .borderRadius(50.percent)
            .boxShadow(
                0.px, 0.px, 32.px, color = rgb(34, 197, 94),
            ),
        contentAlignment = Alignment.Center
    ) {
        Box(
            Modifier
                .size(90.px)
                .backgroundColor(AppTheme.colors.background)
                .borderRadius(50.percent)
                .border(4.px, LineStyle.Solid, Color.rgb(34, 197, 94)),
            contentAlignment = Alignment.Center
        ) {
            // Checkmark
            Div({
                style {
                    property("width", "40px")
                    property("height", "40px")
                    property("border-radius", "50%")
                    property("display", "flex")
                    property("align-items", "center")
                    property("justify-content", "center")
                }
            }) {
                // SVG checkmark
                Svg(
                    attrs = {
                        attr("width", "40")
                        attr("height", "40")
                        attr("viewBox", "0 0 24 24")
                        attr("fill", "none")
                        attr("stroke", "#22C55E")
                        attr("stroke-width", "3")
                        attr("stroke-linecap", "round")
                        attr("stroke-linejoin", "round")
                    }
                ) {
                    Path {
                        attr("d", "M5 13l4 4L19 7")
                    }
                }
            }
        }
    }
}